<div class="banner">
  <div class="banner-background" [ngStyle]="backgroundImageStyle()">
    <div class="banner-container">
      <h1
        class="banner-title"
        [innerHTML]="'homepage.banner_title' | translate"></h1>
      <p class="banner-subtitle">
        {{ 'homepage.banner_subtitle' | translate }}
      </p>
    </div>
  </div>
</div>

<div class="links">
  <div class="links-container">
    <a class="link-element" [href]="travelEdgeUrl">
      {{ 'homepage.book_travel' | translate }}
    </a>
    <a class="link-element" [routerLink]="['/gift_card']">
      {{ 'homepage.gift_cards' | translate }}
    </a>
    <a class="link-element" [routerLink]="['/transfer']">
      {{ 'homepage.transfer_miles' | translate }}
    </a>
    <a class="link-element" [routerLink]="['/redeem_cash']">
      {{ 'homepage.cashback' | translate }}
    </a>
  </div>
</div>
